import { Easing, Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import Renderable from '../../../Component/Renderable';
import ElementComponent from '../../../Component/UI/Element';
import { AwaitIterators } from '../AnimationHelper';

export class SuitcaseTutorialOpen extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        gameObject.find('ftux').getComponent(Renderable).visible = true;

        const shine: GameObject = gameObject.find('ftux/shine');
        const item: GameObject = gameObject.find('ftux/unlocked_item');
        const text: GameObject = gameObject.find('ftux/unlocked_text');
        const btnContinue: GameObject = gameObject.find('ftux/continue_button');

        const shineElem: ElementComponent = shine.getComponent(
            ElementComponent
        );

        const itemElem: ElementComponent = item.getComponent(ElementComponent);

        const txtRenderable: Renderable = text.getComponent(Renderable);
        txtRenderable.alpha = 0;

        const btnRenderable: Renderable = btnContinue.getComponent(Renderable);
        btnRenderable.alpha = 0;

        // Ray rotation loop.
        const shineChild = gameObject.find('ftux/shine').children[0];
        const shineChildElem = shineChild.getComponent(ElementComponent);
        shineChildElem.layout.angle = 0;
        const tweenRotation: Tween = this.getTween(shineChildElem.layout);
        tweenRotation
            .to({ angle: 360 }, 10000)
            .repeat(Infinity)
            .start(this.elapsedTime);

        // Scale.
        shineElem.layout.scale = [0, 0];
        const shineTween: Tween = this.getTween(shineElem.layout.scale);
        shineTween.to({ 0: 3, 1: 3 }, 500).easing(Easing.Cubic.InOut);

        itemElem.layout.scale = [0, 0];
        const itemTween: Tween = this.getTween(itemElem.layout.scale);
        itemTween.to({ 0: 2, 1: 2 }, 500).easing(Easing.Back.Out);

        yield* AwaitIterators([
            this.startTween(shineTween),
            this.startTween(itemTween),
        ]);

        // Fade in.
        const txtFadeInTween: Tween = this.getTween(txtRenderable);
        txtFadeInTween.to({ alpha: 1 }, 500).start(this.elapsedTime);

        const btnFadeInTween: Tween = this.getTween(btnRenderable);
        btnFadeInTween.to({ alpha: 1 }, 500);

        yield* this.startTween(btnFadeInTween);

        while (true) yield;
    }
}
